// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import config from 'client/config'

const Http404 = (): any => <div className='login'>
  <span className='login__accent' />
  <div className='login__header'>
    <h3 className='login__title'>Something went wrong</h3>
    <h4 className='login__subtitle'>There was an issue logging you in. Please contact <a className='login__inline-link' href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a></h4>
  </div>
  <Link to='/' className='login__link'>Return to Login Page</Link>
</div>

export default Http404
